;
define("global_views_modal.tpl", function(){});

